import { marqueeItems } from "@/data/site";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {marqueeItems.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-6 font-display text-xl font-bold uppercase tracking-wider text-white/80 sm:px-10 sm:text-2xl">
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-neon" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-white/10 bg-surface/60 py-5"
    data-testid="marquee"
  >
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
  </div>
);
